<template>
  <div id="tabsComp">
    <div v-for="(tab,index) in tabs" :key="index">
      <button :class="['tab', tab.active?'active':'']" @click="tabClick(tab.data)">{{tab.title}}</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'tabsComp',
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
  },
  props: {
    moduleName: {
      type: String,
      required: true
    }
  },
  computed: {
    tabs: function () { return this.$store.getters[`${this.moduleName}/getTabs`] }
  },
  methods: {
    tabClick (data) {
      this.$store.dispatch(`${this.moduleName}/setActiveTab`, { param: data })
    }
  }
}
</script>

<style scoped lang="scss">

#tabsComp {
  margin: 32px 32px 0 32px;
  display: -webkit-flex;
  display: flex;
  justify-content: flex-start;
}
.tab {
  object-fit: contain;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #202020;
  border: none;
  background: none;
}
.active {
  border-bottom: 3px solid #ff8200;
}
.active:active, .active:hover {
  opacity: 1;
}
button:active, button:hover {
  opacity: 0.5;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}

</style>
